<template>
  <div class="discount-container">
    <h2>Gültige Rabatte pro Artikel</h2>

    <div v-if="Object.keys(discountsPerArticle).length === 0" class="no-data">
      Keine gültigen Rabatte für die aktuellen Artikel gefunden.
    </div>

    <div v-for="(discounts, posId) in discountsPerArticle" :key="posId" class="article-card">
      <div class="article-header">
        <strong>Artikel-ID: {{ posId }}</strong>
        <span class="badge">{{ discounts.length }} Rabatt(e)</span>
      </div>

      <ul class="discount-list">
        <li v-for="discount in discounts" :key="discount.name">
          <span class="discount-name">{{ discount.name }}</span>
          <span class="discount-value">-{{ discount.percentage }}%</span>
        </li>
      </ul>
    </div>

    <div class="pa-10" style="white-space: pre">DEBUG discounts <br>{{ JSON.stringify($store.getters.discounts, null, 2) }}</div>

  </div>
</template>

<script>
import {getValidDiscountsForArticle} from "./discountsUtil";
import {cloneMe} from "../vendor/util";

export default {
  name: 'DiscountsDebugpage',
  props: {
    // Liste der IDs, die aktuell geprüft werden sollen (z.B. aus dem Warenkorb)
    articleIds: {
      type: Array,
      default: () => ["34", "35", "99"] // 99 als Beispiel für Globalen Rabatt
    },
    currentUseCase: {
      type: String,
      default: "takeAway"
    }
  },
  computed: {
    // Das Herzstück: Die Map { posId: [RabattObjekte] }
    discountsPerArticle() {
      const allDiscounts = cloneMe(this.$store.getters.discounts);
      console.log('allDiscounts', allDiscounts);
      const resultMap = {};

      this.articleIds.forEach(id => {
        const validOnes = getValidDiscountsForArticle(allDiscounts, id, this.currentUseCase);
        console.log('ermittelte discounts für posId ' + id + ' ' + validOnes.length);
        if (validOnes.length > 0) {
          resultMap[id] = validOnes;
        }
      });

      return resultMap;
    }
  },
  methods: {}
};
</script>

<style scoped>
.discount-container {
  font-family: sans-serif;
  max-width: 500px;
  margin: 20px auto;
  padding-top: 100px;
}

.article-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  background: #f9f9f9;
}

.article-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  margin-bottom: 8px;
}

.badge {
  background: #4caf50;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8em;
}

.discount-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.discount-list li {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  color: #333;
}

.discount-value {
  font-weight: bold;
  color: #e91e63;
}

.no-data {
  text-align: center;
  color: #888;
  padding: 20px;
}
</style>
